import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";

const EntryFactor = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response37 = useInvoke("WebApps", "37", {});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    useEffect(() => {

        //get entry factors
        if (response37.data.payload != undefined) {
            let myData = JSON.parse(response37.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[1]}`, link: `/EntryFactor/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[2]}`}},
              ];
              rowsList.push(row);
            });
            setColumns(["Entry Factor", "Date Added"]);
            setRows(rowsList);
        }

    }, [response37.data.payload]);

    document.title = "Entry Factors";
    return ( 
        <div className="entryFactors">
            {user["email"] != undefined && 
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Entry Factors</h2>
                        <p><Link className="btn btn-primary" to="/EntryFactor/New">New EntryFactor</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
            
        </div>
     );
}
 
export default EntryFactor;